/* sparesczar-about.js — scroll animations, parallax, counter */
(function () {
  'use strict';

  /* Mark body so CSS knows JS is running — enables hide-then-reveal */
  document.documentElement.classList.add('scz-about-js-ready');

  /* ---- Scroll-triggered fade-in / slide-up ---- */
  const observerOpts = { threshold: 0.12, rootMargin: '0px 0px -20px 0px' };

  const revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('scz-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, observerOpts);

  document.querySelectorAll('.scz-reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ---- Staggered children reveal ---- */
  const staggerObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var children = entry.target.querySelectorAll('.scz-stagger-child');
        children.forEach(function (child, i) {
          child.style.transitionDelay = (i * 0.12) + 's';
          child.classList.add('scz-visible');
        });
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.scz-stagger').forEach(function (el) {
    staggerObserver.observe(el);
  });

  /* ---- Animated counters ---- */
  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 2000;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); /* easeOutCubic */
      var current = Math.floor(eased * target);
      el.textContent = current.toLocaleString() + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString() + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var counters = entry.target.querySelectorAll('[data-count]');
        counters.forEach(function (el) { animateCounter(el); });
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.scz-counter-row').forEach(function (el) {
    counterObserver.observe(el);
  });

  /* ---- Hero parallax ---- */
  var heroOrb = document.querySelector('.scz-about-hero__orb');
  var heroSection = document.querySelector('.scz-about-hero');

  if (heroOrb && heroSection) {
    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      var heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      if (scrollY < heroBottom) {
        heroOrb.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }
})();
